import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Formula } from 'src/app/core/_models/formula';
import { ProductFormulaService } from 'src/app/core/_services/product.formula.service';

@Component({
  selector: 'app-dialog-formula-composition',
  templateUrl: './dialog-formula-composition.component.html',
  styleUrls: ['./dialog-formula-composition.component.scss']
})
export class DialogFormulaCompositionComponent implements OnInit {
  currentItem: Formula = {};

  constructor(
    public dialogRef: MatDialogRef<DialogFormulaCompositionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private productFormulaService: ProductFormulaService
  ) {}

  ngOnInit(): void {
    this.productFormulaService.getFormulaComposition(this.data.resourceId).subscribe((formula) => {
      this.currentItem.produits = formula;
    });
  }
}
